import Skeleton from 'react-loading-skeleton';

export default function RateFormLoader({
  showRatingValues = false,
}: {
  showRatingValues?: boolean;
}) {
  return (
    <div className="flex flex-col gap-3x w-full pb-3x h-auto">
      {showRatingValues && (
        <div className="flex flex-col gap-2x w-full ">
          <Skeleton height={24} />
          <div className="flex gap-x items-center w-full">
            {[...Array(3)].map((_, rowIndex) => {
              return (
                <div
                  className="flex flex-col gap-x items-center w-[109px]"
                  key={rowIndex}
                >
                  <Skeleton width={48} height={48} borderRadius="50%" />
                  <Skeleton height={24} width={70} />
                </div>
              );
            })}
          </div>
        </div>
      )}
      {!showRatingValues && (
        <div className="flex flex-col gap-2x">
          <Skeleton height={24} width={150} />
          {[...Array(9)].map((_, rowIndex) => {
            return (
              <div className="gap-2x justify-start flex  " key={rowIndex}>
                <Skeleton height={24} width={24} borderRadius={4} />
                <Skeleton height={24} width={300} />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
